import { CustomerPreferences } from '@kaa/api/customers';

export const PreferencesScreenFieldNames: {
  SUPPORT_TYPE_PREFERENCE: keyof CustomerPreferences;
} = {
  SUPPORT_TYPE_PREFERENCE: 'supportTypePreference',
};
